import { gsap } from "@/gsap/GsapLoader";

export class MainMenu {
  constructor(el) {
    this.el = el;
    this.menu_cards = el.querySelectorAll("[data-menu-card]");
    this.menu_bg = el.querySelectorAll("[data-menu-bg]");

    this.timeline = null;
  }

  reset() {
    gsap.set(this.el, { opacity: 0, x: "0%" });
    gsap.set(this.menu_cards, { y: "30px", opacity: 0 });
    gsap.set(this.menu_bg, { opacity: 0 });
    this.timeline != null ? this.timeline.kill() : "";
    this.timeline = null;
  }

  open() {
    this.timeline != null ? this.timeline.kill() : "";
    this.timeline = gsap.timeline();

    this.timeline.set(this.el, { x: "100%" }, "before_open");
    this.timeline.fromTo(
      this.el,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        duration: 0.3,
      },
      "open"
    );
    this.timeline.fromTo(
      this.menu_bg,
      { opacity: 0 },
      { opacity: 1, ease: "none" },
      "open"
    );
    this.timeline.fromTo(
      this.menu_cards,
      {
        opacity: 0,
        y: "30px",
      },
      {
        opacity: 1,
        y: "0px",
        duration: 0.3,
        ease: "none",
      },
      "first_show"
    );
  }

  close() {
    this.timeline != null ? this.timeline.kill() : "";
    this.timeline = gsap.timeline();

    this.timeline.fromTo(
      this.menu_cards,
      {
        opacity: 1,
        y: "0px",
      },
      {
        opacity: 0,
        y: "30px",
        duration: 0.3,
        ease: "none",
      },
      "first_show"
    );

    this.timeline.fromTo(this.menu_bg, { opacity: 1 }, { opacity: 0 }, "close");
    this.timeline.fromTo(
      this.el,
      {
        opacity: 1,
      },
      {
        opacity: 0,
      },
      "close"
    );
    this.timeline.set(this.el, { x: "0%" }, "after_close");
  }
}
